(() => {
  'use strict';

  const initChainUpsells = (scope = document) => {
    const root = scope && scope.querySelectorAll ? scope : document;

    root.querySelectorAll('[data-chain-upsell]').forEach(function (upsell) {
      if (upsell.dataset.chainInit === 'true') return;
      upsell.dataset.chainInit = 'true';

      const track = upsell.querySelector('[data-chain-track]');
      const prev = upsell.querySelector('[data-chain-prev]');
      const next = upsell.querySelector('[data-chain-next]');
      const radios = upsell.querySelectorAll('[data-chain-radio]');
      const productDetails = upsell.closest('.product-details');
      const addToCartButton = productDetails
        ? productDetails.querySelector(
            'button[id^="BuyButtons-ProductSubmitButton-"], .meller-add-to-cart-wrap .button, .meller-add-to-cart-wrap .button-secondary, .meller-add-to-cart-wrap .add-to-cart-button'
          )
        : null;

      let selectedUpsellVariantId = null;
      let isAddingUpsell = false;

      const getGap = function () {
        if (!track) return 12;
        const styles = window.getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || 12);
        return isNaN(gap) ? 12 : gap;
      };

      const getStep = function () {
        const item = upsell.querySelector('[data-chain-item]');
        if (!item) return 180;
        return item.getBoundingClientRect().width + getGap();
      };

      let navFrame = 0;
      const updateNavigation = function () {
        navFrame = 0;
        if (!track) return;

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const currentScroll = Math.max(0, track.scrollLeft);
        const atStart = currentScroll <= 1;
        const atEnd = currentScroll >= maxScroll - 1;

        if (prev) {
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', String(atStart));
        }

        if (next) {
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', String(atEnd));
        }
      };

      const requestNavigationUpdate = function () {
        if (navFrame) return;
        navFrame = window.requestAnimationFrame(updateNavigation);
      };

      if (prev && track) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });
      }

      if (next && track) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        });
      }

      if (track) {
        track.addEventListener('scroll', requestNavigationUpdate, { passive: true });
        updateNavigation();

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(requestNavigationUpdate);
          resizeObserver.observe(track);
        }
      }

      radios.forEach(function (radio) {
        const selector = radio.closest('.meller-chain-upsell__selector');

        if (selector) {
          selector.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const wasChecked = radio.checked;

            if (wasChecked) {
              radio.checked = false;
              selectedUpsellVariantId = null;
              return;
            }

            radios.forEach(function (item) {
              item.checked = false;
            });

            radio.checked = true;
            selectedUpsellVariantId = radio.dataset.chainVariantId || radio.value || null;
          });
        }

        radio.addEventListener('change', function () {
          if (this.checked) {
            selectedUpsellVariantId = this.dataset.chainVariantId || this.value || null;
          } else if (selectedUpsellVariantId === (this.dataset.chainVariantId || this.value || null)) {
            selectedUpsellVariantId = null;
          }
        });

        if (radio.checked) {
          selectedUpsellVariantId = radio.dataset.chainVariantId || radio.value || null;
        }
      });

      if (!addToCartButton) return;

      addToCartButton.addEventListener(
        'click',
        function () {
          if (!selectedUpsellVariantId || isAddingUpsell || addToCartButton.disabled) return;

          isAddingUpsell = true;

          setTimeout(function () {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(selectedUpsellVariantId),
                    quantity: 1
                  }
                ]
              })
            })
              .then(function (response) {
                if (!response.ok) throw new Error('No se pudo agregar la correa');
                return response.json();
              })
              .then(function () {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
              })
              .catch(function (error) {
                console.error('Error al agregar correa:', error);
              })
              .finally(function () {
                setTimeout(function () {
                  isAddingUpsell = false;
                }, 600);
              });
          }, 250);
        },
        true
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initChainUpsells(document), { once: true });
  } else {
    initChainUpsells(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initChainUpsells(event.target || document);
  });
})();
